import { LOAD_TRANSLATIONS_SUCCESS } from './translation-actions';

interface LoadTranslationsAction {
    type: 'LOAD_TRANSLATIONS_SUCCESS';
    translations: object;
}

type KnownAction = LoadTranslationsAction;

export const translationsReducer = (
    state: object | null | undefined = null,
    action: KnownAction
) => {
    switch (action.type) {
        case LOAD_TRANSLATIONS_SUCCESS:
            return action.translations;
        default:
            return state;
    }
};
